module.exports = __webpack_public_path__ + "images/cam-star-a11125cad8e330261778c5ef050c5baa.png";